import { backgroundColor, textColor } from "@/lib/style";

const LoadingScreen = ({message}: {message?: string}) => {
    return (
        <div className="absolute inset-0 bg-black bg-opacity-75 flex items-center justify-center">
            <div className={`p-6 ${backgroundColor} ${textColor} rounded-lg max-h-[90vh] overflow-y-auto w-[600px] flex items-center justify-center`}>
                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z">
                        <animateTransform attributeName="transform" type="rotate" dur="0.75s" values="0 12 12;360 12 12" repeatCount="indefinite"/>
                    </path>
                </svg>
                <span className="ml-2">{message ?? "Loading..."}</span>
            </div>
        </div>
    );
};

export default LoadingScreen;